import {
  AdminCMSRoleApiRequest,
  DeleteAdminCMSRoleApiRequest,
  UpdateAdminCMSRoleApiRequest,
} from '@/data/payload/api/AdminCMSRoleRequest'
import {
  DeleteAdminCMSRoleInterface,
  PostAdminCMSRoleInterface,
  UpdateAdminCMSRoleInterface,
} from '@/data/payload/contracts/AdminCMSRoleRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { AdminCMSRoleDataMapper } from '@/data/persistences/mappers/AdminCMSRoleDataMapper'
import { AdminCMSRoleRepositoryInterface } from '@/data/persistences/repositories/contracts/AdminCMSRoleRepositoryInterface'
import { RoleCMSS } from '@/domain/entities/AdminCMSRole'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class AdminCMSRoleApiRepository
  implements AdminCMSRoleRepositoryInterface {
  private service: ApiService
  private mapper: AdminCMSRoleDataMapper

  constructor(service: ApiService, mapper: AdminCMSRoleDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async post(payload: PostAdminCMSRoleInterface): Promise<RoleCMSS> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.ADMIN_CMS_ROLE_ADD,
      undefined,
      payload as AdminCMSRoleApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async getAll(params: object): Promise<RoleCMSS> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.ADMIN_CMS_ROLE,
      params
    )
    return this.mapper.convertAdminCMSRoleFromApi(resp)
  }

  public async delete(payload: DeleteAdminCMSRoleInterface): Promise<RoleCMSS> {
    // console.log('disinii')

    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.ADMIN_CMS_ROLE_DELETE,
      undefined,
      payload as DeleteAdminCMSRoleApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdateAdminCMSRoleInterface,
    id: number
  ): Promise<RoleCMSS> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.ADMIN_CMS_ROLE_UPDATE}/${id}`,
      undefined,
      payload as UpdateAdminCMSRoleApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }
}
